import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=97f3c28c&scoped=true"
import script from "./ExportButton.vue?vue&type=script&lang=js"
export * from "./ExportButton.vue?vue&type=script&lang=js"
import style0 from "./ExportButton.vue?vue&type=style&index=0&id=97f3c28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f3c28c",
  null
  
)

export default component.exports